import React, { useState, useEffect } from "react";
import { Form, Select, Input } from "antd";
import get from "lodash/get";
import map from "lodash/map"
import find from "lodash/find"

const rejectedScrapTypeSelect = ({ name, rowIndex, form, config }) => {
    const [isOtherSelected, setIsOtherSelected] = useState(false);
    useEffect(() => {
        if (form.getFieldValue([
            "components",
            name,
            "parts_full",
            rowIndex,
            "meta",
            "rejected_scrap_type",
        ]) === 10) {
            const selectedScrap = find(get(config, "extrusion_scrap_type"), ['value', form.getFieldValue([
                "components",
                name,
                "parts_full",
                rowIndex,
                "meta",
                "rejected_scrap_type",
            ])])
            if (get(selectedScrap, "hasRemarkInput")) {
                setIsOtherSelected(true)
            }else{
                form.setFieldValue(['components',name, "parts_full", rowIndex, "meta", "scrap_name"],'')
            }
        }
    }, [form])
    return (
        <>
            <Form.Item
                name={[name, "parts_full", rowIndex, "meta", "rejected_scrap_type"]}
            >
                <Select options={map(get(config, "extrusion_scrap_type"), item => {
                    return {
                        ...item,
                        label: get(item, "name"),
                    }
                })}
                    placeholder="Rejected Scrap Type"
                    onChange={value => {
                        const selectedScrap = find(get(config, "extrusion_scrap_type"), ['value', value]);
                        if (get(selectedScrap, "hasRemarkInput")) {
                            setIsOtherSelected(true)
                        }
                        else {
                              form.setFieldValue(['components',name, "parts_full", rowIndex, "meta", "scrap_name"],'')
                            setIsOtherSelected(false)
                        }
                    }}
                    className="w-full"
                    size="small"
                />
            </Form.Item>
            {(isOtherSelected) && (
                <Form.Item
                    name={[name, "parts_full", rowIndex, "meta", "scrap_name"]}
                    rules={[
                        {
                            required: true,
                            message: "Please Enter Scrap Name"
                        }
                    ]}
                >
                    <Input
                        className="w-full"
                        placeholder="Scrap Name"
                        size="small"
                    />
                </Form.Item>
            )}
        </>
    )
}

export default rejectedScrapTypeSelect